import { Observable } from 'rxjs';
import { get, isEmpty, omit } from 'lodash';
import CarryOutOrderService from 'apis/services/carryOutOrder';
import { getDefaultPaginationStatus } from 'status/schemas/pagination';

export const initialState = getDefaultPaginationStatus();
const FETCH_CARRY_OUT_ORDER = Symbol('FETCH_CARRY_OUT_ORDER');
const FETCH_CARRY_OUT_ORDER_SUCCESS = Symbol('FETCH_CARRY_OUT_ORDER_SUCCESS');

export const fetchCarryOutOrder = params => ({ type: FETCH_CARRY_OUT_ORDER, payload: params });
export const fetchCarryOutOrderSuccess = response => ({
  type: FETCH_CARRY_OUT_ORDER_SUCCESS,
  payload: response,
});

export const fetchCarryOutOrderEpic = (action$, store$) => action$
  .ofType(FETCH_CARRY_OUT_ORDER)
  .filter((action, index) => {
    const order = store$.value.carryOutOrder;
    if (index === 0) {
      return true;
    }
    if (get(action, 'payload.forceRefresh', false)) {
      return true;
    }
    if (isEmpty(order.results)) {
      return false;
    }
    return get(action, 'payload.page', 0) !== get(order, 'current_page', -1);
  })
  .mergeMap(
    action => Observable
      .fromPromise(CarryOutOrderService.fetch(omit(action.payload, 'forceRefresh')))
      .map(response => fetchCarryOutOrderSuccess(response)),
  );


export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CARRY_OUT_ORDER_SUCCESS:
      return { ...action.payload.data };
    default:
      return state;
  }
};
